<template>
  <boxwrap class="games--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <select-list
          class="toolbar-nav"
          :title="$route.params.type || 'all'"
          v-model="type"
          @input="change"
        >
          <select-option
            value="all"
            name="all"
          >
            <span>all</span>
          </select-option>wal

          <select-option
            value="sports"
            name="sport"
          >
            <span>sport</span>
          </select-option>

          <select-option
            value="live"
            name="live"
          >
            <span>live</span>
          </select-option>
        </select-list>

        <search
          class="search-bar-wrap -withdropdown"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @refresh="search"
          @trigger="trigger"
        >
        </search>

        <button
          class="btn--create"
          title="create"
          @click="showCreate = true"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
        >
          <i class="ico--delete"></i>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>

          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>

          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>
      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>

      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner>
          <tbl-head>
            <tbl-row>
              <tbl-td class="checkbox">
                <checkbox>
                  <input type="checkbox" />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                @click.native="sort('id')"
                v-if="checkCol('no', tblSetting)"
              >
                no
              </tbl-td>

              <tbl-td
                name="game-type"
                :sort="true"
                @click.native="sort('game_type')"
                v-if="checkCol('game_type', tblSetting)"
              >
                game type
              </tbl-td>

              <tbl-td
                name="icon"
                v-if="checkCol('icon', tblSetting)"
              >
                icon
              </tbl-td>

              <tbl-td
                name="name-en"
                :sort="true"
                @click.native="sort('name')"
                v-if="checkCol('name_en', tblSetting)"
              >
                name (en)
              </tbl-td>

              <tbl-td
                name="name-kr"
                :sort="true"
                @click.native="sort('kor')"
                v-if="checkCol('name_kr', tblSetting)"
              >
                name (ko)
              </tbl-td>

              <tbl-td
                name="is-live"
                :sort="true"
                @click.native="sort('live')"
                v-if="checkCol('is_live', tblSetting)"
              >
                is live
              </tbl-td>

              <tbl-td
                name="is-active"
                :sort="true"
                @click.native="sort('active')"
                v-if="checkCol('is_active', tblSetting)"
              >
                is active
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                created at
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                updated at
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                deleted at
              </tbl-td>

              <tbl-td
                class="delete-edit"
                v-if="checkPermission"
              >
              </tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(game, id) in all"
              :key="game.id"
              @click.native="showModifyPopup(game)"
              :class="{'is-deleted': game.deleted_at}"
            >
              <tbl-td class="checkbox" @click.native.stop>
                <checkbox>
                  <input type="checkbox" />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="no"
                v-if="checkCol('no', tblSetting)"
              >
                {{ generateNumber(id, params.page, params.rows, params.sort, count || 0) }}
              </tbl-td>

              <tbl-td
                class="game-type"
                v-if="checkCol('game_type', tblSetting)"
              >
                {{ game.type_meta }}
              </tbl-td>

              <tbl-td
                class="icon"
                v-if="checkCol('icon', tblSetting)"
              >
                <img
                  v-if="game.image"
                  :src="basePath + game.image"
                />
              </tbl-td>

              <tbl-td
                class="name-en"
                v-if="checkCol('name_en', tblSetting)"
              >
                {{ game.name }}
              </tbl-td>

              <tbl-td
                class="name-kr"
                v-if="checkCol('name_kr', tblSetting)"
              >
                {{ game.kor }}
              </tbl-td>

              <tbl-td
                class="is-live"
                v-if="checkCol('is_live', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="enabled"
                  toggleB="disabled"
                  @click.native.stop.prevent="toggleGameLive(game)"
                >
                  <input
                    type="checkbox"
                    v-model="game.live"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="is-active"
                v-if="checkCol('is_active', tblSetting)"
              >
                <checkbox
                  type="toggle"
                  class="toggle--inverted"
                  toggleA="active"
                  toggleB="inactive"
                  @click.native.stop.prevent="toggleGameActive(game)"
                >
                  <input
                    type="checkbox"
                    v-model="game.active"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                class="created-at"
                v-if="checkCol('created_at', tblSetting)"
              >
                {{ game.created_at | date }}
              </tbl-td>

              <tbl-td
                class="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                --need data--
              </tbl-td>

              <tbl-td
                class="deleted-at"
                v-if="checkCol('deleted_at', tblSetting)"
              >
                {{ game.deleted_at | date }}
              </tbl-td>

              <tbl-td
                class="delete-edit"
                v-if="checkPermission"
              >
                <button
                  class="btn--delete"
                  @click.stop="deletData(game.id)"
                >
                  <i class="ico--delete"></i>
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="count"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create"
      title="create new game"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <form
          class="form-con"
          @submit.prevent="save"
        >
          <div class="form-items">
            <div class="form-lbl"><span>game name (en)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input v-model="newGame.name" type="text" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game name (kr)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input v-model="newGame.kor" type="text" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game type</span></div>
            <div class="form-data">
              <select-list
                :title="newGame.type"
                :withReset="true"
                v-model="newGame.type"
              >
                <select-option
                  :key="type.id"
                  :value="type.id"
                  :name="type.name"
                  v-for="type in types"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>live</span></div>
            <div class="form-data">
              <checkbox
                type="toggle"
                class="toggle--inverted"
                toggleA="enable"
                toggleB="disable"
              >
                <input
                  type="checkbox"
                  v-model="newGame.live"
                />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>active</span></div>
            <div class="form-data">
              <checkbox
                type="toggle"
                class="toggle--inverted"
                toggleA="active"
                toggleB="inactive"
              >
                <input
                  type="checkbox"
                  v-model="newGame.active"
                />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="file-upload-wrap">
                <label for="upload-game-image" class="file-upload-con">
                  <i class="ico--upload"></i>
                  <input ref="newGameimage" type="file" id="upload-game-image" class="file-upload"/>
                </label>
              </div>
            </div>
          </div>

        </form>
      </template>

      <template slot="footer">
        <button
          class="btn--create -withlabel"
          @click="save('newGame')"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--modify-game"
      title="modify game"
      v-if="showModify"
      :activate="showModify"
      @activate="showModify = $event"
    >
      <template slot="body">
        <form
          class="form-con"
          @submit.prevent="save"
        >
          <div class="form-items">
            <div class="form-lbl"><span>game name (en)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input v-model="editGame.name" type="text" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game name (kr)</span></div>
            <div class="form-data">
              <div class="input-wrap">
                <input v-model="editGame.kor" type="text" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>game type</span></div>
            <div class="form-data">
              <select-list
                :title="displayType(editGame.type)"
                :withReset="true"
                v-model="editGame.type"
              >
                <select-option
                  :key="type.id"
                  :value="type.id"
                  :name="type.name"
                  v-for="type in types"
                >
                  {{ type.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>live</span></div>
            <div class="form-data">
              <checkbox
                type="toggle"
                class="toggle--inverted"
                toggleA="enable"
                toggleB="disable"
              >
                <input
                  type="checkbox"
                  v-model="editGame.live"
                />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>active</span></div>
            <div class="form-data">
              <checkbox
                type="toggle"
                class="toggle--inverted"
                toggleA="active"
                toggleB="inactive"
              >
                <input
                  type="checkbox"
                  v-model="editGame.active"
                />
              </checkbox>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>Image</span></div>
            <div class="form-data">
              <div class="file-upload-wrap">
                <label for="upload-game-image" class="file-upload-con">
                  <i class="ico--upload"></i>
                  <input ref="editGameimage" type="file" id="upload-game-image" class="file-upload"/>
                </label>
              </div>
            </div>
          </div>
        </form>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="save('editGame')"
        >
          <i class="ico--save"></i>
          Modify
        </button>
      </template>
    </modal>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import Modal from '@/components/base/Modal'

import '@/components/base/table/Table'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'games',

  components: {
    Checkbox,
    Pagination,
    Search,
    CheckDataList,
    Modal
  },

  mixins: [
    swal,
    checkAll
  ],

  data () {
    return {
      type: this.$route.params.type,
      status: this.$route.params.status,
      showTblSettings: false,
      showCreate: false,
      showModify: false,

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      tblSetting: 'games_list',

      allCols: [
        {
          value: 'no',
          display: 'no'
        },
        {
          value: 'game_type',
          display: 'game type'
        },
        {
          value: 'name_en',
          display: 'name (en)'
        },
        {
          value: 'name_kr',
          display: 'name (kr)'
        },
        {
          value: 'is_live',
          display: 'is live'
        },
        {
          value: 'is_active',
          display: 'is active'
        },
        {
          value: 'created_at',
          display: 'created at'
        },
        {
          value: 'updated_at',
          display: 'updated at'
        },
        {
          value: 'deleted_at',
          display: 'deleted at'
        },
        {
          value: 'delete',
          display: 'delete'
        },
        {
          value: 'icon',
          display: 'icon'
        }
      ],

      filterBy: [
        {
          value: 'name',
          display: 'Name'
        },
        {
          value: 'kor',
          display: 'Korean Name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      editGame: {
        name: '',
        kor: '',
        image: null,
        type: null,
        live: false,
        active: false
      },

      newGame: {
        name: '',
        kor: '',
        image: null,
        type: null,
        live: false,
        active: false
      }
    }
  },

  watch: {
    $route ($router) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      this.search(this.generate($router.query))
    }
  },

  computed: {
    ...mapGetters('game', ['all', 'types', 'count']),
    basePath () {
      return process.env.VUE_APP_STATIC_ASSET_PATH || '/'
    },

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    }
  },

  async created () {
    await this.getTypes({}); await this.get({
      params: this.params, status: this.status, type: this.type
    })
    await this.getCount(this.params)

    // == flags set
    this.isDataLoading = false
    this.showDataLoading = false
    if (!this.all.length) {
      this.isEmpty = true
    }
  },

  methods: {
    ...mapActions(
      'game', ['get', 'create', 'update', 'delete', 'getTypes', 'getCount']
    ),

    change () {
      this.$router.push(`/games/status/${this.status}/type/${this.type}`)
    },

    displayType (id) {
      return this.types.find((e) => { return e.id === id }).name
    },

    trigger (query) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.$router.push({
        path: `/games/status/${this.status}/type/${this.type}`,
        query: this.params
      })
    },

    async search (query) {
      this.params = query || this.params

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.get({
        params: this.params, status: this.status, type: this.type
      })

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.all.length) {
        this.isEmpty = true
      }
    },

    async save (key) {
      let alertTitle = key === 'newGame' ? 'Create Game' : 'Modify Game'
      let success = async () => {
        this.showModify = false
        this.showCreate = false
        this.showDataLoading = true

        if (this.$refs[`${key}image`] && this.$refs[`${key}image`].files &&
          this.$refs[`${key}image`].files.length) {
          this[key].image = this.$refs[`${key}image`].files[0]
        }

        try {
          if (!this[key].id) {
            await this.create(this[key])
            await this.get({
              params: this.params, status: this.status, type: this.type
            })
            this.$alert('success', 'You have successfully created game(s).', {}, '', 'Success')
          } else {
            await this.update(this[key])
            this.$alert('success', 'You have successfully modified game(s).', {}, '', 'Success')
          }
        } catch (err) {
          console.log(err)
        }

        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, alertTitle)
    },

    async deletData (id) {
      let success = async () => {
        await this.delete(id)
        this.get({
          params: this.params, status: this.status, type: this.type
        })
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Delete ?')
    },

    showModifyPopup (game) {
      if (this.checkPermission) {
        this.editGame = Object.assign({}, game)
        this.showModify = true
      }
    },

    toggleGameActive (game) {
      let success = async () => {
        game.active = !game.active
        await this.update(game)
      }

      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Modify ?')
    },

    toggleGameLive (game) {
      let success = async () => {
        game.live = !game.live
        await this.update(game)
      }
      this.$alert('prompt', 'Are you sure you want to proceed ?', {}, { success }, 'Modify ?')
    },

    sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      this.trigger()
    }
  }
}
</script>
